import { render } from "./TagsFilter.vue?vue&type=template&id=4c013b35"
import script from "./TagsFilter.vue?vue&type=script&lang=js"
export * from "./TagsFilter.vue?vue&type=script&lang=js"

import "./TagsFilter.vue?vue&type=style&index=0&id=4c013b35&lang=scss"

import exportComponent from "C:\\Users\\chervinskii_mk\\Documents\\ORIS\\Repositories\\site\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__